import type { PossibleBusinessObject } from '@iotv/iotv-v3-types'
import type { ValidModelType } from '../classDependentTypes/ValidModelClasses'
import type { UserAttributeDefs } from '../types/ModelTypes'
import { ModelCommon } from './ModelCommon'

const commonSupportedTypes = ['Gateway', 'Device', 'User', 'Customer'].sort((a, b) => a.localeCompare(b))

const supportedTypes = Object.fromEntries(
  [...commonSupportedTypes]
    .filter((x) => x)
    .map((type) => [type, type])
    .sort(),
)

const typeName = 'Group'

class Group extends ModelCommon {
  constructor({ supportedType, ...ob }: PossibleBusinessObject & { supportedType?: ValidModelType }) {
    super(ob.type ?? typeName, ob)
    this.supportedType = supportedType
  }

  supportedType: ValidModelType | undefined

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      supportedType: {
        type: this.supportedType && commonSupportedTypes.includes(this.supportedType) ? 'Enum' : 'String',
        editable: false,
        required: true,
        enumKv: supportedTypes,
      },
    }
  }
}

export { Group }
